import { render, staticRenderFns } from "./MainImagesAddon.vue?vue&type=template&id=638a57ea&scoped=true"
import script from "./MainImagesAddon.vue?vue&type=script&lang=js"
export * from "./MainImagesAddon.vue?vue&type=script&lang=js"
import style0 from "./MainImagesAddon.vue?vue&type=style&index=0&id=638a57ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a57ea",
  null
  
)

export default component.exports